/**
 * Created by summer on 2020/9/22.
 */
import {
    http
} from '../../../common/http/axios.js'
import { ImagePreview, Toast } from "vant";
let utils = {
    formateDate: (date) => {
        let dateObj = {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate(),
        }
        var systemDate = dateObj.year + '-' + (dateObj.month >= 10 ? dateObj.month : '0' + dateObj.month) + '-' + (dateObj.day >= 10 ? dateObj.day : '0' + dateObj.day);
        return systemDate;
    },
    iconUrl:{
        //教练点评
        add01 : require('@/assets/img/add01.png'),
        //内部评价
        add02 : require('@/assets/img/add02.png'),
        /** 家长START */
        //为绑定孩子
        invite_bg : require('@/assets/img/present/bing_bg.png'),
        
        //背景
        bg_icon : require('@/assets/img/present/bg_my.png'),
        //男士图标
        man_icon : require('@/assets/img/present/man_icon.png'),
        //女士图标
        women_icon : require('@/assets/img/present/women_icon.png'),
        //游泳图标
        icon01 : require('@/assets/img/present/my_icon01.png'),
        //游泳图标
        icon02 : require('@/assets/img/present/my_icon02.png'),
        //课程预约
        yuyue : require('@/assets/img/present/yuyue.png'),
        //课时明细
        mingxi : require('@/assets/img/present/mingxi.png'),
        //教练点评
        my_list01 : require('@/assets/img/present/my_list01.png'),
        //反馈消息
        my_list02 : require('@/assets/img/present/my_list02.png'),
        //接触绑定
        my_list03 : require('@/assets/img/present/my_list03.png'),
        //退出账号
        my_list04 : require('@/assets/img/present/my_list04.png'),
        //为绑定孩子
        my_list05 : require('@/assets/img/present/my_list05.png'),
        //邀请人
        my_list06 : require('@/assets/img/present/my_list06.png'),
        //连续约课
        my_list07 : require('@/assets/img/present/my_list07.png'),
        //首页
        footer01 : require('@/assets/img/present/footer01.png'),
        footer01_on : require('@/assets/img/present/footer01_on.png'),
        //我的
        footer02 : require('@/assets/img/present/footer02.png'),
        footer02_on : require('@/assets/img/present/footer02_on.png'),
        bind : require('@/assets/img/present/bind.png'),
        choose : require('@/assets/img/present/choose.png'),
        choose_on : require('@/assets/img/present/choose_on.png'),
        // 编辑
        edit : require('@/assets/img/present/edit.png'),
        // 切换
        switch : require('@/assets/img/present/switch.png'),
        add : require('@/assets/img/present/add.png'),
        /** 家长END */
        /** 教练端START */
        //课时统计
        count : require('@/assets/img/coach/count.png'),
        /** 教练端END */
        /** 课程START */
        //上传照片
        photo : require('@/assets/img/class/photo.png'),
        //课时明细
        period01 : require('@/assets/img/class/period_icon01.png'),
        period02 : require('@/assets/img/class/period_icon02.png'),
        /** 课程END */

        /** 登录START */
        swimming : require('@/assets/img/login/swimming_icon.png'),
        login_bg : require('@/assets/img/login/bg.png'),
        login_slogn : require('@/assets/img/login/slogn.png'),
        /** 登录END */
    },
    showImg: (url) => {
        ImagePreview({
            images: [
                url
            ],
            closeable: true,
            showIndex: false
        });
    },
    wxConfig: ((url) => {
        let self = this;
        url = url.replace(location.hash, '');

        return new Promise(function (resolve, reject) {
            http(
                "/api/swimming/getWechatJssdk",
                { url: url },
                "post"
            )
                .then((res) => {
                    if (res) {
                        var jsondata = res.data.data;
                        //【注-------------这里根据自己后台的返回的数据做相应的调整---------------】
                        wx.config({
                            // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            debug: false,
                            // 必填，公众号的唯一标识
                            appId: jsondata.appId,
                            // 必填，生成签名的时间戳
                            timestamp: "" + jsondata.timestamp,
                            // 必填，生成签名的随机串
                            nonceStr: jsondata.nonceStr,
                            // 必填，签名
                            signature: jsondata.signature,
                            // 必填，需要使用的JS接口列表
                            jsApiList: [
                                "chooseImage", //拍照或从手机相册中选图接口
                                "previewImage", //预览图片接口
                                "uploadImage", //上传图片接口
                                "downloadImage", //下载图片接口
                                'openLocation', //打开定位
                            ],
                        });
                        wx.ready(() => {
                            resolve('wx注入ready');
                            console.log('wx注入ready')
                        })
                        wx.error((res) => {
                            reject(JSON.stringify(res))
                            console.log(JSON.stringify(res))
                            if(res.errMsg == 'config:ok'){
                                resolve(res);
                            }else{
                                reject('fail')
                            }
                            // window.$wxConfigError++
                            // console.error('微信config注入失败：' + res)
                            // console.log('重新注入微信config')
                        })
                    }
                })
                .catch((error) => {
                    reject(`获取失败：${error.message}`)
                    console.error(`获取失败：${error.message}`);
                });
        });
    }),
}
export default utils;




// WEBPACK FOOTER //
// ./src/assets/js/public.js